<template>
  <b-card>
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
    <div slot="header">
      <i
        class="fa fa-list-ul"
        aria-hidden="true"
      ></i>
      User Profile
      <div class="card-header-actions">
        <a
          href="https://bootstrap-vue.js.org/docs/components/progress"
          class="card-header-action"
          rel="noreferrer noopener"
          target="_blank"
        >
          <small class="text-muted">docs</small>
        </a>
      </div>
    </div>
    <b-row>
      <b-col sm="12">
        <alert-success :show="successMessage != ''"> {{ successMessage }} </alert-success>
        <b-alert
          class="text-center"
          :show="errorMessage != ''"
          variant="danger"
        > {{ errorMessage }} </b-alert>
        <transition
          name="custom-classes-transition"
          enter-active-class="animated fadeInDown"
        >
          <div v-if="!passwordOnly">
            <!-- Thumbnail -->
            <b-form-group>
              <div class="text-center">
                <img
                  class="thumbnail"
                  :src="previewThumbnail"
                  alt="Thumbnail"
                >
              </div>
              <b-input-group>
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    @change="thumbnailFile"
                  >
                  <label class="custom-file-label"> {{ thumbnail.name || 'choose thumbnail file' }} </label>
                </div>
                <b-button
                  variant="outline-secondary"
                  @click="previewThumbnail = '/images/avatars/default.jpg'; thumbnail = {}"
                >
                  Set Default
                </b-button>
              </b-input-group>
            </b-form-group>

            <!-- Fullname -->
            <b-form-group>
              <label>Fullname</label>
              <b-input-group>
                <b-input
                  :state="feedback(fieldErrors.fullname)"
                  v-model="form.fullname"
                  placeholder="please insert fullname"
                ></b-input>
              </b-input-group>
            </b-form-group>

            <!-- Permission -->
            <b-form-group>
              <label>Permission</label>
              <v-select :disabled="true" v-model="form.permission" multiple :options="permissionList" :placeholder="'please select permissions of user'"></v-select>
            </b-form-group>
          </div>
        </transition>
        <transition
          name="custom-classes-transition"
          enter-active-class="animated fadeInDown"
        >
          <div v-if="passwordOnly">
            <!-- Old Password -->
            <b-form-group>
              <label>Old Password</label>
              <b-input-group>
                <b-input
                  type="password"
                  :state="feedback(fieldErrors.oldPassword)"
                  v-model="form.oldPassword"
                  placeholder="please enter old password"
                ></b-input>
              </b-input-group>
            </b-form-group>
            <!-- Password -->
            <b-form-group>
              <label>Password</label>
              <b-input-group>
                <b-input
                  type="password"
                  :state="feedback(fieldErrors.newPassword)"
                  v-model="form.newPassword"
                  placeholder="please enter new password"
                ></b-input>
              </b-input-group>
            </b-form-group>
            <!-- Confirm Password -->
            <b-form-group>
              <label>Confirm Password</label>
              <b-input-group>
                <b-input
                  type="password"
                  :state="feedback(fieldErrors.confirmPassword)"
                  v-model="form.confirmPassword"
                  placeholder="please enter confirm new password"
                ></b-input>
              </b-input-group>
            </b-form-group>
          </div>
        </transition>
      </b-col>
    </b-row>
    <div slot="footer">
      <b-button
        @click="$router.go(-1)"
        class="mr-2"
        size="sm"
        variant="secondary"
      >
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
        ></i>
        Back
      </b-button>
      <b-button
        :disabled="!isActive"
        @click="save"
        class="mr-2"
        type="submit"
        size="sm"
        variant="primary"
      >
        <i class="fa fa-dot-circle-o"></i>
        Save
      </b-button>
      <b-button
        v-if="!registerType"
        @click="changePassword"
        class="mr-2"
        type="submit"
        size="sm"
        variant="outline-dark"
      >
        <i class="fa fa-dot-circle-o"></i>
        {{changePasswordLabel}}
      </b-button>
    </div>
  </b-card>
</template>

<script>
import AlertSuccess from '../../components/alert/AlertSuccess';
import vSelect from 'vue-select';
import Loading from '../../components/Loading';
import UserProfile from '@/models/userprofile.js';

export default {
  data () {
    return {
      id: null,
      successMessage: '',
      errorMessage: '',
      previewThumbnail: '/images/avatars/default.jpg',
      thumbnail: {},
      fieldErrors: {},
      form: {
        username: '',
        status: 'active',
        permission: [],
        newPassword: null,
        confirmPassword: null,
        oldPassword: null
      },
      registerType: true, // true = firebase, false = directly
      isActive: true,
      isLoading: false,
      passwordOnly: false,
      changePasswordLabel: 'Change Password',
      tempPassword: null,
      permissionList: [],
      updatedAvatar: false
    };
  },
  methods: {
    thumbnailFile (e) {
      const files = e.target.files || e.dataTransfer.files;
      this.form.thumbnail = files[0];
      this.form.isDefaultThumbnail = false;
      this.updatedAvatar = true;
      this.previewThumbnail = URL.createObjectURL(this.form.thumbnail);
    },
    handleError (error) {
      console.log('Error : ', error);
      if (error.response) {
        let errorData = error.response.data.data;
        this.errorMessage = errorData.map(value => value.msg).join(', ');
      } else {
        this.errorMessage = error.response || error.message;
      }
    },
    save () {
      this.errorMessage = '';
      this.isActive = false;
      this.isLoading = true;
      if (this.passwordOnly) {
        const formData = new FormData();
        formData.append('oldPassword', this.form.oldPassword);
        formData.append('newPassword', this.form.newPassword);
        formData.append('confirmPassword', this.form.confirmPassword);
        this.axios.patch(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/reset-password', formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'Update user success !';
          })
          .catch(error => {
            this.isActive = true;
            this.isLoading = false;
            this.handleError(error.response.data);
          });
      } else {
        const formData = new FormData();
        formData.append('fullname', this.form.fullname);
        formData.append('permission', this.form.permission);
        formData.append('thumbnail', this.form.thumbnail);
        if (this.updatedAvatar) {
          this.$root.$emit('avatar', URL.createObjectURL(this.form.thumbnail));
        }
        this.axios.patch(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/profile', formData)
          .then(response => {
            this.isLoading = false;
            this.successMessage = 'Update user success !';
          })
          .catch(error => {
            this.isActive = true;
            this.isLoading = false;
            this.handleError(error.response.data);
          });
      // }
      }
    },
    changePassword () {
      this.errorMessage = '';
      this.passwordOnly = (!this.passwordOnly) || false;
      if (this.passwordOnly) {
        this.changePasswordLabel = 'Cancel Change Password';
        this.tempPassword = this.form.newPassword;
        this.form.newPassword = '';
      } else {
        this.changePasswordLabel = 'Change Password';
        this.form.newPassword = this.tempPassword;
      }
    },
    getData () {
      const username = this.$route.params.username;
      this.isActive = false;
      this.isLoading = true;
      this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/user/' + username)
        .then(response => {
          const data = response.data.data;
          const userprofile = new UserProfile(data.user);
          this.id = data.user.id;
          this.form = userprofile;
          this.previewThumbnail = userprofile.thumbnail || '/images/avatars/default.jpg';
          this.registerType = 'directly' !== userprofile.type;
        })
        .catch(error => {
          this.handleError(error);
        })
        .finally(() => {
          this.isActive = true;
          this.isLoading = false;
        });
    },
    getPermissionList () {
      this.permissionList = [];
      this.axios.get(process.env.VUE_APP_ACCESS_CONTROL_URL + '/permission')
        .then(response => {
          const data = response.data.data;
          if (data) {
            for (const permission of data.permissions) {
              this.permissionList.push(permission.name);
            }
          }
        })
        .catch(error => {
          this.handleError(error);
        });
    },
    setDefault () {
      this.form = {
        username: '',
        status: 'active',
        permission: [],
        newPassword: null,
        confirmPassword: null
      };
      this.registerType = 'firebase';
      this.id = null;
    }
  },
  computed: {
    feedback () {
      return data => {
        if (!data) {
          return null;
        } else {
          return data.isCorrect;
        }
      };
    },
    registerTypeText () {
      return this.registerType ? 'Firebase' : 'Directly';
    },
    isUpdate () {
      return null != this.id;
    }
  },
  mounted () {
    this.getPermissionList();
    this.getData();
  },
  watch: {
    '$route' (to, from) {
      this.setDefault();
      this.getData();
    }
  },
  components: {
    AlertSuccess,
    'v-select': vSelect,
    'app-loading': Loading
  }
};
</script>

<style scoped>
.thumbnail {
  width: auto;
  max-height: 40px;
  -webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.75);
  margin-bottom: 5px;
}
</style>
